import Model from './Model';


const PROPERTIES = {
  id: {
    name: 'ID',
  },
  name: {
    name: 'Name',
  },
  dateCreated: {
    name: 'Date created',
  },
  url: {
    name: 'URL',
  },
  moduleVersion: {
    name: 'Module version',
  },
  apiVersion: {
    name: 'API version',
  },
  trafficUsage: {
    name: 'Traffic usage',
  },
  customHooksInUse: {
    name: 'Custom hooks in use',
  },
};


class Environment extends Model {
  getWhitelistedProperties() {
    return PROPERTIES;
  }
}


export default Environment;
